module.exports = __webpack_public_path__ + "static/Dima-0b51b77b3f83076fee4931856eeca43f.jpg";